import Layout from '@/components/layout/Layout.vue'
import { getPromotionReports, updatePromotionByField, copyPromotion} from '@/api/promotion'
import { getMedias } from '@/api/constant'
import moment from 'moment'
import CreateForm from '@/views/sys/promotion/report/create/Create.vue'
import YjqlForm from '@/views/sys/promotion/yjql/Yjql.vue'

export default {
    name: 'promotionReport',
    components: {
        Layout,
        CreateForm,
        YjqlForm,
    },
    props: {
        showPromotionReportPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            data: [],
            loading: false,
            medias: [],
            columns: [
                { minWidth: 250, title: '广告名称', field: 'name', slots: { default: 'name' } },
                { minWidth: 120, title: '状态', field: 'status_name', slots: { default: 'status' } },
                { minWidth: 120, title: '充值', field: 'total_amount', formatter: 'empty'},
                { minWidth: 80, title: '消耗', field: 'stat_cost', sortable: true, formatter: 'empty'},
                { minWidth: 100, title: 'roi', field: 'roi', formatter: 'roi', type: 'html'},
                { minWidth: 120, title: '出价', field: 'bid',  slots: { default: 'bid' }},
                { minWidth: 100, title: '预算', field: 'budget',  slots: { default: 'budget' }},
                { minWidth: 100, title: '千次展现', field: 'cpm_platform', sortable: true, formatter: 'empty'},
                { minWidth: 90, title: '点击率', field: 'ctr', sortable: true, formatter: item => {
                    return item.row.ctr ? item.row.ctr + '%' : '-'
                }},
                { minWidth: 100, title: '点击单价', field: 'cpc_platform', sortable: true, formatter: 'empty'},

                { minWidth: 130, title: this.model.media_name+'转化成本', field: 'conversion_cost', sortable: true, formatter: 'empty'},
                { minWidth: 120, title: this.model.media_name+'转化率', field: 'conversion_rate', sortable: true, formatter: item => {
                    return item.row.conversion_rate ? item.row.conversion_rate + '%' : '-'
                }},
                { minWidth: 120, title: this.model.media_name+'转化数', field: 'convert_cnt', sortable: true, formatter: 'empty'},


                { minWidth: 110, title: '真实转化成本', field: 'real_conversion_cost', formatter: 'empty'},
                { minWidth: 100, title: '真实转化率', field: 'real_conversion_rate', formatter: item => {
                    return item.row.real_conversion_rate ? item.row.real_conversion_rate + '%' : '-'
                }},
                { minWidth: 100, title: '真实转化数', field: 'real_conversion_cnt',  formatter: 'empty'},


                { minWidth: 90, title: '展示数', field: 'show_cnt', sortable: true, formatter: 'empty'},
                { minWidth: 90, title: '点击数', field: 'click_cnt', sortable: true, formatter: 'empty'},

                // { minWidth: 130, title: '真实转化', field: 'real_conversion',   slots: { default: 'real_conversion' }},
               

            ],
            queryParam: {
                date: [this.model.started_at,this.model.finished_at]
            },
            channels: [],
            platforms: [],
            showForm: false,
            showYjqlForm: false,
            workers: [],
            tableGrid: this.getTableGrid(),
            preview: {},
            preview_loading: false,
            new_ad_name: null,
            promotionModel: {},
            showCopyForm: false,
            modelForm: {},
            modelYjql: {},
        }
    },
    watch: {
         
    },
    mounted() {
        this.tableGrid.columns = this.columns
        getMedias().then(res => { this.medias = res.data.list || [] })
        this.getData()
    },
    created() {
        if ([2].includes(this.model.media)) {
            this.columns.splice(6, 0, { minWidth: 100, title: '一键起量', field: 'yjql',  slots: { default: 'yjql' }});
            this.columns.splice(17, 0,   { minWidth: 160, title: '操作', slots: { default: 'action' },fixed: 'right', },);
        }
    },
    methods: {
        getTableGrid() {
            let grid = this.$helper.tableGrid('mediaMaterial')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
       
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize,
                advertiser_id: this.model.advertiser_id,
            })
            this.$helper.buildDateRangeParams(json, 'date')

            if (!json.started_at || !json.finished_at) {
                return this.$message.error('请选择查询日期')
            }
            getPromotionReports(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list.list
                this.data = res.data.list.list || []
            }).catch(() => {
                this.loading = false
                this.tableGrid.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        accessTo(route) {
            let controller = 'PromotionController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        close() {
            this.$emit('update:showPromotionReportPage', false)
        },
        updatePromotion(id, field,  value) {
            this.loading = true
            const data = {
                advertiser_id: this.model.advertiser_id,
                id: id,
                field: field,
                value: value
            }
            updatePromotionByField(data).then(res => {
                const actionType = value === 'ENABLE' ? '暂停广告' : '启用广告'
                this.$message.destroy()
                if (res.code === 0) {
                    this.$message.success(actionType+'成功')
                } else {
                    this.model.opt_status =  this.model.opt_status === 'ENABLE' ? 'DISABLE' : 'ENABLE'
                }
                this.refresh()
            }).catch(() => {
                this.loading = false
                this.data = []
                this.refresh()
            })
        },
        copyPromotion (item) {
            let promotion = item.promotion
            let timeRegex = /(_\d{2}_\d{2}_\d{2}:\d{2}:\d{2})/;
            this.new_ad_name = item.name.replace(timeRegex, moment().format('_MM_DD_HH:mm:ss'))

            this.promotionModel = promotion
            this.showCopyForm = true
        },
        closePromotionForm () {
            this.showCopyForm = false
        },
        submitPromotion () {
            this.promotionModel.ad_name = this.new_ad_name
            // console.log('开始提交,提交数据:', this.promotionModel)
            // this.refresh()
            // this.closePromotionForm()

            this.loading = true
            copyPromotion(this.promotionModel).then(res => {
                this.$message.destroy()

                if (res && res.code === 0) {
                    this.$message.success('复制成功')
                    this.refresh()
                    this.closePromotionForm()
                } else {
                    this.$message.error(res.message)
                }

                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        jumpToOrder (item) {
            // 【已停用】订单列表页面已下线，跳转不再可用
            // this.$router.push({
            //     name: 'orders', // 目标页面的路由名称
            //     query: {
            //         juliang_ad_id: item.promotion_id, // 查询参数
            //         platform_id: item.pt.platform_id,
            //     }
            // });
            this.$message.warning(`订单列表页面已下线（推广ID：${item.promotion_id}）`)
        },
        showFormPage (item, field) {
            // console.log(this.model,item, type)
            this.modelForm = {
                promotion_id:item.promotion_id,
                advertiser_id:this.model.advertiser_id,
                [field]: item[field],  // 使用 field 动态设置字段
                field: field,
                value: item[field]
            }
            this.showForm = true
        },
        showYjqlFormPage (item) {
            // console.log(this.model,item)
            this.modelYjql = {
                promotion_id:item.promotion_id,
                advertiser_id:this.model.advertiser_id,
                raise_info: [],
            }
            this.showYjqlForm = true
        },
    }
}
